import { FEATURES } from '../features/capabilities/constants';
import { routingConfig } from './navigation.constants';

/** Shapes the table below. Private on purpose: `ShowroomSectionKey` is the public handle. */

/**
 * The one place a Build Your Offer section is declared: its key, its former standalone path, and
 * the sidebar order. Everything else in this file derives from it, so adding a section here is the
 * whole change. The helpers that read it -- `isShowroomSectionKey`, `sectionKeyFromPathname` --
 * live in `sales-checkin-ui-utils/routing/showroomNavigation`, because they are behaviour.
 */
export const BUILD_YOUR_OFFER_SECTIONS = [
    { key: FEATURES.VEHICLE_DETAILS, path: routingConfig.VEHICLE_DETAILS },
    { key: FEATURES.TRADE_IN, path: routingConfig.TRADE_IN },
    { key: FEATURES.CUSTOMER_DETAILS, path: routingConfig.FINANCING },
    { key: FEATURES.DEAL_SUMMARY, path: routingConfig.DEAL_SUMMARY }
];

export type ShowroomSectionKey = (typeof BUILD_YOUR_OFFER_SECTIONS)[number]['key'];

/**
 * The sections that hand off to a full-screen takeover, mapped to its address. Declared before
 * `TakeoverSectionKey` so the key derives from the map rather than being a second list to keep in
 * step -- the same way `ShowroomSectionKey` derives from the table above.
 */
export const TAKEOVER_ROUTES = {
    [FEATURES.TRADE_IN]: routingConfig.TRADE_IN_TAKEOVER,
    [FEATURES.CUSTOMER_DETAILS]: routingConfig.CUSTOMER_DETAILS_TAKEOVER
};

export type TakeoverSectionKey = keyof typeof TAKEOVER_ROUTES;
